<template>
    <div class="append-to-body">
        <div class="modal micromodal-slide" :id="(newCategory.slug)?'edit-category':'new-category'" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true">
                    <div class="modal__content" id="modal-new-category-content">
                        <h3>{{ title }}</h3>
                        <div class="form__group flex">
                            <input type="text" name="category_name" class="form__control" :placeholder="'Enter a name for the ' + categoryType" v-model="newCategory.name">
                        </div>
                    </div>
                    <footer class="modal__footer">
                        <button class="btn btn-danger" v-on:click.stop.prevent="deleteCategoryModal" v-if="newCategory.slug">
                            <i class="icon ion-md-trash"></i>
                        </button>
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-primary" v-on:click.stop.prevent="createCategory">{{ title }}</button>
                    </footer>
                </div>
            </div>
        </div>

        <div class="modal micromodal-slide" :id="'delete-category-' + newCategory.slug" aria-hidden="true" v-if="newCategory.slug">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true">
                    <div class="modal__content" id="modal-new-category-content">
                        <h3>Delete {{ categoryType }} "{{ newCategory.name}}"</h3>
                        <p>Are you sure you wish to delete "{{ newCategory.name }}"?</p>
                        <p v-if="categoryType === 'folder'">All files will be moved to the top level folder and all sub folders will be deleted.</p>
                    </div>
                    <footer class="modal__footer">
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-danger" v-on:click.stop.prevent="deleteCategory">Delete</button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import MicroModal from 'micromodal';

    export default {
        props: {
            category : {
                default: null
            },
            categoryType : {
                type: String,
                default: 'folder'
            }
        },
        data() {
            return {
                newCategory:{
                    name: null,
                    slug: null
                }
            }
        },
        watch: {
            category: {
                handler() {
                    if( this.category && this.category !== null ){
                        this.getCategory()
                    }
                }
            }
        },
        computed: {
            type: function(){
                if( this.category !== null){
                    return "edit";
                }else{
                    return "create";
                }
            },
            title: function(){
                if( this.category !== null ){
                    return "Edit " + this.categoryType;
                }else{
                    return "Create " + this.categoryType;
                }
            }
        },
        created() {
            if( this.category && this.category !== null ){
                this.getCategory();
            }
        },
        mounted() {
            // append modal elements to body
            document.querySelectorAll('.append-to-body').forEach( element => {
                // console.log(element);
                element.classList.remove('append-to-body');
                document.body.appendChild(element);
            });
        },
        methods: {
            ...mapActions({
                clearGroupCache: 'group/clearCache'
            }),
            getCategory(){
                axios.get('/api/groups/' + this.$route.params.group + '/categories/' + this.category).then((response) => {
                    this.newCategory = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            createCategory(){
                if( this.category !== null ){
                    axios.put('/api/groups/' + this.$route.params.group + '/categories/' + this.category, this.newCategory).then((response) => {
                        this.clearGroupCache();
                        this.$emit('edit-category', response.data);
                        MicroModal.close('edit-category');
                        
                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    axios.post('/api/groups/' + this.$route.params.group + '/categories', this.newCategory).then((response) => {
                        this.clearGroupCache();
                        this.$store.commit('group/addCategory', response.data);
                        
                        MicroModal.close('new-category');

                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            deleteCategoryModal(){
                MicroModal.close('edit-category');
                MicroModal.show('delete-category-' + this.newCategory.slug);
            },
            deleteCategory(){
                if( this.category !== null ){
                    axios.delete('/api/groups/' + this.$route.params.group + '/categories/' + this.category).then((response) => {
                        this.clearGroupCache();
                        
                        MicroModal.close('delete-category-' + this.newCategory.slug);
                        this.$router.push({ name: 'view-group', params: { group: this.$route.params.group } });
                        this.$emit('delete-category', true);
                    }, (response) => {
                        this.error = response;
                    });
                }
            }
        }
    }
</script>